module.exports = __webpack_public_path__ + "img/20250827_Laurenz-14.196bd51b.jpg";